<template>
    <nav class="navbar navbar-expand-lg">
        <div class="container-fluid">
            <router-link class="navbar-brand" to="/">
                <img :src="require('@/assets/logo.png')" alt="logo" style="height: 40px;">
            </router-link>
        </div>
    </nav>
    <div class="text-center">
        <img class="img-fluid mb-3" :src="require('@/assets/login.png')" />
    </div>
</template>

<script>
// Logo bar and hero shared by the public pages: login, forgot password and
// reset password.
export default {
    name: 'AuthHeader',
};
</script>
